const VerifoneIntegrationType = require('../../VerifoneIntegrationType');

class AbstractVerifoneRequestRecord {
    /**
     * @param {string} integrationType
     *
     * @return {[]}
     */
    toArray(integrationType) {
        return integrationType ? [] : [];
    }

    /**
     * @param {string} integrationType
     *
     * @return {string}
     */
    toString(integrationType) {
        let str = this.toArray(integrationType).join(',');

        if (integrationType !== VerifoneIntegrationType.EVO) {
            str += '\r\n';
        }

        return str;
    }
}

module.exports = AbstractVerifoneRequestRecord;
